import React, { useState, useEffect } from "react";
import "../../../../src/styles/userManagement.css";
import {Modal} from "@appkit4/react-components/modal"
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import {Select} from "@appkit4/react-components/select";
import {Button} from "@appkit4/react-components/button"
import displayToastMessage from "../../Common/Alert/displayToastMessage";
import "./role.css";
import PropTypes from 'prop-types'
import APIService from "../../../services/apiAxiosService";
import useHttp from "../../../hooks/useHttp";
import {Table, Column} from "@appkit4/react-components/table";
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";

export default function Role(props) {
  let { Roles, allOrganizations, handleDelete, loader, reloadData,deletemodalVisible,setDeletemodalVisible } = props;

  const [visible, setVisible] = useState(false);
  const [updateModalVisible, setUpdateModalVisible] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState("");
  const [errorOrgMessage, setErrorOrgMessage] = useState("");
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [errorRoleMessage, setErrorRoleMessage] = useState("");
  const [isErrorMessageShown, setIsErrorMessageShown] = useState(false);
  const [orgRoles, setOrgRoles] = useState([]);
  const [roles, setRoles] = useState([]);
  const [mainRoles, setMainRoles] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [userId, setUserId] = useState({});
  const [initialSelectedUsers, setInitialSelectedUsers] = useState([]);
  const [orgid, setOrgid] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalPage, setTotalPage] = useState(500);
  const { sendRequest: FetchOrgRoles } = useHttp();
  const { sendRequest: AddrolesToOrganization } = useHttp();
  const { sendRequest: EditrolesToOrganization } = useHttp();
  const { sendRequest: getExistRolesById } = useHttp();

  const showModal = () => {
    setVisible(true);
    setEditMode(false);
  };
  const showUpdateModal = () => {
    setUpdateModalVisible(true);
  };
  const handleCancel = (e) => {
    setVisible(false);
    setUpdateModalVisible(false);
    setEditMode(false);
    setDeletemodalVisible(false);
  };
  const handleConfirm = (e) => {
    setVisible(false);
    setUpdateModalVisible(false);
  };

  const GetOrgRoles = async () => {
    FetchOrgRoles(APIService.FetchOrgRoles(), (data) => {
      setOrgRoles(data.MSG)
      setFilter(data.MSG);
      setTableData(data.MSG);
      let totalPageLength = Math.ceil((data.MSG.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
      setTotalPage(totalPageLength);
    })
  };

  useEffect(() => {
    const result = tableData?.filter((organizationList) => {
      return organizationList.org_name.toLowerCase().match(search.toLocaleLowerCase());
    });
    setFilter(result);
    let totalPageLength = Math.ceil((result.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
      setTotalPage(totalPageLength);
  }, [search]);

  useEffect(() => {
    GetOrgRoles();
    setRoles(Roles);
    setMainRoles(Roles);
  }, [Roles, loader]);

  useEffect(() => {
    if (!loader) {
      setDeletemodalVisible(false);
    }
  }, [loader]);

  const GetAlreadyExistedOrgRoles = async (SelectedOrganization) => {
    let _roles = [...mainRoles];
    for (let each of orgRoles) {
      if (each.org_id === SelectedOrganization) {
        let IndexRole = _roles.findIndex((r) => r.roleid === each.role_id);
        if (IndexRole !== -1) {
          _roles.splice(IndexRole, 1);
        }
      }
    }
    setRoles(_roles);
  };

  const handleAddRoles = async () => {

    if (selectedOrg === "") {
      setErrorOrgMessage("Please select Organization");
      setIsErrorMessageShown(true);
      return false;
    }
    if (selectedRoles.length == 0) {
      setErrorRoleMessage("Please select Roles");
      setIsErrorMessageShown(true);
      return false;
    }
    let addedAndDeleted = findDeselectedItem(
      selectedRoles,
      initialSelectedUsers
    );
    let userData = [];
      addedAndDeleted[0]?.map((item, index) => {
        userData.push({
          orgid: orgid,
          roleId: item,
          flag: "unchecked",
          created_by: 2,
          email:sessionStorage.getItem("email"),
         });
      });
      addedAndDeleted[1]?.map((item, index) => {
        userData.push({
          orgid: orgid,
          roleId: item,
          flag: "checked",
          created_by: 2,
         email:sessionStorage.getItem("email"),
      });
      });
    let payload = {
      org_id: selectedOrg,
      roles: selectedRoles,
      created_by: 2,
      email:sessionStorage.getItem("email"),
    };
    if (editMode) {
      try {
        EditrolesToOrganization(APIService.EditrolesToOrganization(userData), (data) => {
          displayToastMessage(data.MSG, "success");
          GetOrgRoles();
        })
        setUpdateModalVisible(false);
        setSearch("");
        setSelectedOrg("");
        setSelectedRoles([]);
        reloadData();
      } catch (error) {
        console.log("Error",error)
        let Msg = "Action failed. Please try again!";
        displayToastMessage(Msg, "error");
        setUpdateModalVisible(false);
        setSearch("");
      }
    } else {
      try {
        AddrolesToOrganization(APIService.AddrolesToOrganization(payload), (data) => {
          displayToastMessage(data.MSG, "success");
          GetOrgRoles();
        })
        setVisible(false);
        setSearch("");
        setSelectedOrg("");
        setSelectedRoles([]);
        reloadData();
      } catch (error) {
        console.log("Error",error)
        let Msg = "Action failed. Please try again!";
        displayToastMessage(Msg, "error");
        setVisible(false);
        setSearch("");
      }
    }
  };
  const selectOrginisation = async (e) => {
    setSelectedOrg(e);
    await GetAlreadyExistedOrgRoles(e);
    setErrorOrgMessage("")
  };
  const selectRolesHandler = (e) => {
    setSelectedRoles(e);
    setErrorRoleMessage("")
  };

  const responseHandler = (result) => {
    let arr = [];
    let data = result.MSG;
    data.map((item) => {
      arr.push(item.roleid);
    });
    setOrgid(data[0].orgid);
    setSelectedRoles(arr);
    setInitialSelectedUsers(arr);
  }

  const getRoleDetailsById = async (orgId) => {
    getExistRolesById(APIService.getExistRolesById(orgId), responseHandler)
  };

  function findDeselectedItem(CurrentArray, PreviousArray) {
    let CurrentArrSize = CurrentArray.length;
    let PreviousArrSize = PreviousArray.length;
    let deletedElements = [];
    let addedElements = [];
    // loop through previous array
    for (let i = 0; i < PreviousArrSize; i++) {
      // look for same thing in new array
      if (CurrentArray.indexOf(PreviousArray[i]) == -1) {
        deletedElements.push(PreviousArray[i]);
      }
    }

    for (let j = 0; j < CurrentArrSize; j++) {
      if (PreviousArray.indexOf(CurrentArray[j]) == -1) {
        addedElements.push(CurrentArray[j]);
      }
    }

    return [deletedElements, addedElements];
  }

  const renderActionCell = (row) => {
    return(
      <>
        <span className="Appkit4-icon icon-edit-fill action-icon pointer" title="Edit Role" onClick={() => handleEditButton(row)}></span> &nbsp;
        <span className=" Appkit4-icon icon-delete-fill action-icon pointer" title="Delete Role" onClick={() => handleDeleteButton(row)}></span>
      </>
    )
  }

  const sortFuncForOrder1 = (a, b) => {
    const firstOrderId = (a.org_name).charAt(1);
    const secondOrderId = (b.org_name).charAt(1);
    return firstOrderId > secondOrderId ? 1 : -1;;
}

const sortFuncForOrder2 = (a, b) => {
  const firstOrderId = (a.org_name).charAt(1);
  const secondOrderId = (b.org_name).charAt(1);
  return firstOrderId < secondOrderId ? 1 : -1;;
}

const handleEditButton = (row) => {
  showUpdateModal();
  setSelectedOrg(row?.org_name);
  setSelectedRoles([row?.role_name]);
  getRoleDetailsById(row?.org_id);
  setEditMode(true);
}

const handleDeleteButton = (row) => {
  setUserId({
    id: row?.org_id,
  });
  setDeletemodalVisible(true);
  
}

  return (
    <div className="App">
      <div className="d-flex justify-content-end pe-3 pt-3">
        <i
          className="Appkit4-icon icon-circle-plus-fill edit-inputadd-icon-fill pointer add-st"
          title="Add Role" onClick={showModal}
        ></i>
        <Modal
          className="baseline-modal-showcase"
          visible={visible}
          onCancel={handleCancel}
          title={editMode ? "Edit Organization Role" : "Add New Organization Role"}
          bodyStyle={{maxHeight:"280px"}}
          footerStyle={{paddingTop:"8px", marginTop:"-8px"}}
          modalStyle={{width:"49.75rem", maxHeight:"fit-content"}}
        >
            <div className="row">
              <div className="col-sm-6">
                <div className="cv-input-field-container">
                  <label htmlFor="Organization" className="cv-input-label">
                    Organization<span className="asterisk-required">*</span>
                  </label>
                  <Select
                    dropdownRenderMode="portal"
                    value={selectedOrg}
                    data={allOrganizations}
                    valueKey="org_id"
                    labelKey="org_name"
                    placeholder="Select organization"
                    showSearchOnToggle={true}
                    onSelect={(e) => selectOrginisation(e)}
                  >
                  </Select>
                </div>
                <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorOrgMessage}
                </span>
              </div>
              </div>

              <div className="col-sm-6">
                <div className="cv-input-field-container">
                  <label htmlFor="Role" className="cv-input-label">
                    Role<span className="asterisk-required">*</span>
                  </label>
                  <Select
                    dropdownRenderMode="portal"
                    type="text"
                    placeholder="Select role"
                    data={roles}
                    valueKey="roleid"
                    labelKey="rolename"
                    onSelect={(e) => selectRolesHandler(e)}
                    value={selectedRoles}
                    multiple={true}
                    showSelectAll={false}
                  >
                  </Select>
                </div>
              </div>
              <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorRoleMessage}
                </span>
              </div>
            </div>
            <div className="organization-container">
            <button
              type="button"
              className="cancel-button-edit-role"
              onClick={handleConfirm}
            >
              Cancel
              </button>
            <button
              type="submit"
              className="save-button-edit-role m-l-2"
              onClick={handleAddRoles}
            >
              Save
              </button>
          </div>
        </Modal>
      </div>
      <div>
        <Modal
          className="baseline-modal-showcase"
          visible={deletemodalVisible}
          onCancel={handleCancel}
          bodyStyle={{maxHeight:"280px"}}
          footerStyle={{paddingTop:"8px", marginTop:"-8px"}}
          modalStyle={{width:"49.75rem", maxHeight:"fit-content"}}
        >
           <div className="modal-title">
          Are you sure you want to delete?
          </div>
          <ModalFooter>
            <button
              type="button"
              className="cancel-button-edit-role"
              onClick={handleCancel}
            >
              No
              </button>
            {loader ? (
              <Button kind="secondary " size="lg" className="load-btn">
                <span className="a-loading a-primary a-m-10 a-loading-16"></span>
              </Button>
            ) : (
              <button
                type="submit"
                className="save-button-edit-role m-l-2"
                onClick={() => handleDelete(userId, setSearch, GetOrgRoles)}
              >
                Yes
              </button>
            )}
          </ModalFooter>
        </Modal>
      </div>

      <div className="d-flex justify-content-end pr-3 pt-3">
        <Modal
          className="baseline-modal-showcase"
          visible={updateModalVisible}
          onCancel={handleCancel}
          title="EDIT ORGANIZATION ROLE"
          bodyStyle={{maxHeight:"280px"}}
          footerStyle={{paddingTop:"8px", marginTop:"-8px"}}
          modalStyle={{width:"49.75rem", maxHeight:"fit-content"}}
        >
            <div className="row">
              <div className="col-sm-6">
                <div className="cv-input-field-container">
                  <label htmlFor="OrganizationRole" className="cv-input-label">
                    Organization<span className="asterisk-required">*</span>
                  </label>
                  <input
                    className="cv-input-field"
                    type="text"
                    id="OrganizationRole"
                    name="organization"
                    value={selectedOrg}
                    disabled
                  />
                </div>
                <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorOrgMessage}
                </span>
              </div>
              </div>

              <div className="col-sm-6">
                <div className="cv-input-field-container">
                  <label htmlFor="Role" className="cv-input-label">
                    Role<span className="asterisk-required">*</span>
                  </label>
                  <Select
                    className="cv-input-field-edit-dropdown mb-2 border-0"
                    dropdownRenderMode="portal"
                    type="text"
                    onSelect={(e) => selectRolesHandler(e)}
                    data={roles}
                    valueKey="roleid"
                    labelKey="rolename"
                    value={selectedRoles}
                    multiple={true}
                    showSelectAll={false}
                    placeholder="Select Role"
                  >
                  </Select>
                </div>
                <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorRoleMessage}
                </span>
              </div>
              </div>
            </div>
            <div className="organization-container">
            <button
              type="button"
              className="cancel-button-edit-role"
              onClick={handleConfirm}
            >
              Cancel
              </button>
            <button
              type="submit"
              className="save-button-edit-role m-l-2"
              onClick={handleAddRoles}
            >
              Save
              </button>
          </div>
        </Modal>
      </div>
      <div className="col-lg-12 mt-3 pl-1">
            <div className="ap-table-demo menu-tableAlignment-width">
              {tableData.length > 0 ? (
                <Input
                type="text"
                title= "Search Organization"
                value={search}
                className="ap-field-wrapper-tableSearch"
                onChange={(e) => setSearch(e)}
              /> 
              ) : ""}
                <Table originalData={filter} hasTitle currentPage={current} pageSize={10}>
                    <Column field="org_name" sortKey={filter.length > 0 ? "org_name" : ""} sortFunc1={sortFuncForOrder1} sortFunc2={sortFuncForOrder2}>Organization</Column>
                    <Column field="role_name" sortKey={filter.length > 0 ? "role_name" : ""}>Role</Column>
                    <Column field="org_id"
                    renderCell={renderActionCell}
                    >Action</Column>
                </Table>
                {filter.length === 0 ? (
                  <div className="noData">
                  No data available in table
                  </div>
                  ) : ("")}
                <Pagination
                  defaultCurrent={1}
                  current={current}
                  total={totalPage}
                  onPageChange={(page) => setCurrent(page)}
                >
                </Pagination>
            </div>
            </div>
    </div>
  );
}

Role.propTypes = {
  Roles: PropTypes.any, 
  allOrganizations: PropTypes.any, 
  handleDelete: PropTypes.any, 
  loader: PropTypes.any, 
  reloadData: PropTypes.any
}
